module.exports = __webpack_public_path__ + "static/img/icon-attention.57c711d2.png";